import { PrayerArray } from "@/schemas/prayer-data-schema";
import {
	WeatherDispatch,
	SetPrevisionMarineDate,
	SetPrayerAction,
	SetPrayerErrorAction,
	SetPrayerLoadingAction,
	setWarningLoadingAction,
	setWarningErrorAction,
	setWarningDataAction,
	setTideLoadingAction,
	setTideErrorAction,
	setTideDataAction,
	setObservationErrorAction,
	setObservationLoadingAction,
	setObservationDataAction,
	setForecastKuwaitLoading,
	setForecastKuwaitError,
	setForecastKuwaitData,
	setObservationDate,
	setWorldCitiesData,
	setWorldCitiesError,
	setWorldCitiesLoading,
	setWorldCitiesLocation,
	setWorldCitiesForecastLoading,
	setWorldCitiesForecastError,
	setWorldCitiesForecastData,
	setWorldCitiesForecastDate,
	setForecastData,
	setForecastLoading,
	setForecastError,
	setForecastCityLocation,
	setForecastCityLoading,
	setForecastCityError,
	setForecastCityData,
	setForecastPrevisionDate,
	setObservationImageryData,
	setObservationImageryError,
	setObservationImageryLoading,
	setObservationFilter,
	setForecastUserLocation,
	setDailyForecastData,
	setDailyForecastError,
	setDailyForecastLoading,
	setDailyForecastStationId,
	setTimelineDataAction,
	setTimelineErrorAction,
	setTimelineLoadingAction,
	setMarineStationData,
	setMarineStationLoading,
	setMarineStationError,
	setMarineLocation,
	setDailyMarineError,
	setDailyMarineLoading,
	setDailyMarineData,
	SetMarineForecastData,
	SetMarineForecastLoading,
	SetMarineForecastError,
} from "./type";
import { WarningSchema } from "@/schemas/warning-data-schema";
import { typeTidesDataSchema } from "@/schemas/tide-data-schema";
import { observationsType } from "@/schemas/observation-schema";
import { CityFeature } from "@/schemas/city-schema";
import { forecastType } from "@/schemas/prevision-data-schema";
import { kuwaitForecastType } from "@/schemas/kuwait-forecast-schema";
import { getClosestPastDate } from "@/helpers/format-date";
import { IWorldCitiesFeatures } from "@/schemas/world-city-schema";
import { WorldForecastSchema } from "@/schemas/world-forecast-schema";
import { imageFilesType } from "@/schemas/imagery-schema";
import { IImageryFilter } from "@/types/imagery-type";
import { IDailyForecastData } from "@/types/daily-forecast-type";
import { TimeLineType } from "@/schemas/timeline-schema";
import { IMarineForecastData } from "@/schemas/marine-forecast-schema";

export const actions = {
	/* les previsions   pour le resolver */
	setForecastData(forecastData: forecastType): setForecastData {
		return {
			type: "SET_FORECAST_DATA",
			forecastData,
		};
	},

	setForecastLoading(isLoading: boolean): setForecastLoading {
		return {
			type: "SET_FORECAST_LOADING",
			isLoading,
		};
	},

	setForecastError(error: string | null): setForecastError {
		return {
			type: "SET_FORECAST_ERROR",
			error,
		};
	},

	/* city data */
	setForecastCityLoading(isLoading: boolean): setForecastCityLoading {
		return {
			type: "SET_FORECAST_CITY_LOADING",
			isLoading,
		};
	},

	setForecastCityError(error: string | null): setForecastCityError {
		return {
			type: "SET_FORECAST_CITY_ERROR",
			error,
		};
	},

	setForecastCityData(payload: CityFeature[]): setForecastCityData {
		return {
			type: "SET_FORECAST_CITY_DATA",
			cityData: payload,
		};
	},

	setDailyForecastData(
		dayliesData: IDailyForecastData[],
	): setDailyForecastData {
		return {
			type: "SET_DAILY_FORECAST_DATA",
			dayliesData,
		};
	},

	setDailyForecastError(error: string | null): setDailyForecastError {
		return {
			type: "SET_DAILY_FORECAST_ERROR",
			error,
		};
	},

	setDailyForecastLoading(isLoading: boolean): setDailyForecastLoading {
		return {
			type: "SET_DAILY_FORECAST_LOADING",
			isLoading,
		};
	},

	setDailyForecastStationId(stationId: string): setDailyForecastStationId {
		return {
			type: "SET_DAILY_FORECAST_STATION_ID",
			stationId,
		};
	},

	setMarineStationData(stations: CityFeature[]): setMarineStationData {
		return {
			type: "SET_MARINE_STATION_DATA",
			stations,
		};
	},

	setMarineStationLoading(isLoading: boolean): setMarineStationLoading {
		return {
			type: "SET_MARINE_STATION_LOADING",
			isLoading,
		};
	},

	setMarineStationError(error: string | null): setMarineStationError {
		return {
			type: "SET_MARINE_STATION_ERROR",
			error,
		};
	},

	setDailyMarineError(error: string | null): setDailyMarineError {
		return {
			type: "SET_DAILY_MARINE_ERROR",
			error,
		};
	},

	setDailyMarineLoading(isLoading: boolean): setDailyMarineLoading {
		return {
			type: "SET_DAILY_MARINE_LOADING",
			isLoading,
		};
	},

	setDailyMarineData(dayliesData: IDailyForecastData[]): setDailyMarineData {
		return {
			type: "SET_DAILY_MARINE_DATA",
			dayliesData,
		};
	},

	setForecastUserLocation(payload: {
		cityId: string;
		cityNameEn: string;
		cityNameAr: string;
	}): setForecastUserLocation {
		return {
			type: "SET_FORECAST_USER_LOCATION",
			...payload,
		};
	},

	setLocation(payload: {
		cityId: string;
		cityNameEn: string;
		cityNameAr: string;
	}): setForecastCityLocation {
		return {
			type: "SET_FORECAST_CITY_LOCATION",
			...payload,
		};
	},

	setMarineLocation(payload: {
		id: string;
		name_en: string;
		name_ar: string;
	}): setMarineLocation {
		return {
			type: "SET_MARINE_LOCATION",
			payload,
		};
	},

	updateObervationDate(payload: Date): setObservationDate {
		return {
			type: "SET_OBSERVATION_DATE",
			date: payload,
		};
	},

	setNewDatePrevision(payload: Date): setForecastPrevisionDate {
		return {
			type: "SET_FORECAST_PREVISION_DATE",
			date: payload,
		};
	},

	updateDateKuwaitForecast(payload: Date) {
		return {
			type: "SET_KUWAIT_FORECAST_DATE",
			date: payload,
		};
	},

	setDateKuwaitForecast(payload: Date) {
		return ({ dispatch }: { dispatch: WeatherDispatch }) => {
			dispatch.updateDateKuwaitForecast(payload);
		};
	},

	setNewMarineDatePrevision(payload: Date): SetPrevisionMarineDate {
		return {
			type: "SET_PREVISION_MARINE_DATE",
			date: payload,
		};
	},

	/* Timeline data pour le resolver */
	setTimelineData(timelineData: TimeLineType[]): setTimelineDataAction {
		return {
			type: "SET_TIMELINE_DATA",
			timelineData,
		};
	},

	setTimelineLoading(isLoading: boolean): setTimelineLoadingAction {
		return {
			type: "SET_TIMELINE_LOADING",
			isLoading,
		};
	},

	setTimelineError(error: string | null): setTimelineErrorAction {
		return {
			type: "SET_TIMELINE_ERROR",
			error,
		};
	},

	/* prayer data pour le resolver */
	setPrayerLoading(isLoading: boolean): SetPrayerLoadingAction {
		return {
			type: "SET_PRAYER_LOADING",
			isLoading,
		};
	},

	setPrayerError(error: string | null): SetPrayerErrorAction {
		return {
			type: "SET_PRAYER_ERROR",
			error,
		};
	},

	setPrayData(payload: PrayerArray): SetPrayerAction {
		return {
			type: "SET_PRAYER_DATA",
			prayerData: payload,
		};
	},

	/* warning data pour le resolver */
	setWarningLoading(isLoading: boolean): setWarningLoadingAction {
		return {
			type: "SET_WARNING_LOADING",
			isLoading,
		};
	},

	setWarningError(error: string | null): setWarningErrorAction {
		return {
			type: "SET_WARNING_ERROR",
			error,
		};
	},

	setWarningData(payload: WarningSchema[]): setWarningDataAction {
		return {
			type: "SET_WARNING_DATA",
			warningData: payload,
		};
	},

	/* tides data pour le resolver */
	setTideLoading(isLoading: boolean): setTideLoadingAction {
		return {
			type: "SET_TIDES_LOADING",
			isLoading,
		};
	},

	setTideError(error: string | null): setTideErrorAction {
		return {
			type: "SET_TIDES_ERROR",
			error,
		};
	},

	setTideData(payload: typeTidesDataSchema): setTideDataAction {
		return {
			type: "SET_TIDES_DATA",
			tidesData: payload,
		};
	},

	/* kuwait forecast data */
	setForecastKuwaitLoading(isLoading: boolean): setForecastKuwaitLoading {
		return {
			type: "SET_KUWAIT_FORECAST_LOADING",
			isLoading,
		};
	},

	setForecastKuwaitError(error: string | null): setForecastKuwaitError {
		return {
			type: "SET_KUWAIT_FORECAST_ERROR",
			error,
		};
	},

	setForecastKuwaitData(payload: kuwaitForecastType): setForecastKuwaitData {
		return {
			type: "SET_KUWAIT_FORECAST_DATA",
			forecastData: payload,
		};
	},

	/* OBSERVATION data  */
	setObservationLoading(isLoading: boolean): setObservationLoadingAction {
		return {
			type: "SET_OBSERVATION_LOADING",
			isLoading,
		};
	},

	setObservationError(error: string | null): setObservationErrorAction {
		return {
			type: "SET_OBSERVATION_ERROR",
			error,
		};
	},

	setObservationData(payload: observationsType[]): setObservationDataAction {
		return {
			type: "SET_OBSERVATION_DATA",
			stationData: payload,
		};
	},

	setObservationImageryLoading(
		isLoading: boolean,
	): setObservationImageryLoading {
		return {
			type: "SET_OBSERVATION_IMAGERY_LOADING",
			isLoading,
		};
	},

	setObservationImageryError(error: string | null): setObservationImageryError {
		return {
			type: "SET_OBSERVATION_IMAGERY_ERROR",
			error,
		};
	},

	setObservationFilter(payload: IImageryFilter): setObservationFilter {
		return {
			type: "SET_OBSERVATION_FILTER",
			filter: payload,
		};
	},

	setObservationImageryData(
		payload: imageFilesType[],
	): setObservationImageryData {
		return {
			type: "SET_OBSERVATION_IMAGERY_DATA",
			imageryData: payload,
		};
	},

	/* marine forecast */
	setMarineForecastData(
		marineData: IMarineForecastData,
	): SetMarineForecastData {
		return {
			type: "SET_MARINE_FORECAST_DATA",
			marineData,
		};
	},

	setMarineForecastLoading(isLoading: boolean): SetMarineForecastLoading {
		return {
			type: "SET_MARINE_FORECAST_LOADING",
			isLoading,
		};
	},

	setMarineForecastError(error: string | null): SetMarineForecastError {
		return {
			type: "SET_MARINE_FORECAST_ERROR",
			error,
		};
	},

	/* World cities */
	setWorldCitiesLoading(isLoading: boolean): setWorldCitiesLoading {
		return {
			type: "SET_WORLD_CITIES_LOADING",
			isLoading,
		};
	},

	setWorldCitiesError(error: string | null): setWorldCitiesError {
		return {
			type: "SET_WORLD_CITIES_ERROR",
			error,
		};
	},

	setWorldCitiesData(payload: IWorldCitiesFeatures): setWorldCitiesData {
		return {
			type: "SET_WORLD_CITIES_DATA",
			worldCitiesData: payload,
		};
	},

	setWorldCitiesForecastLoading(
		isLoading: boolean,
	): setWorldCitiesForecastLoading {
		return {
			type: "SET_WORLD_CITIES_FORECAST_LOADING",
			isLoading,
		};
	},

	setWorldCitiesForecastError(
		error: string | null,
	): setWorldCitiesForecastError {
		return {
			type: "SET_WORLD_CITIES_FORECAST_ERROR",
			error,
		};
	},

	setWorldCitiesForecastData(
		payload: WorldForecastSchema,
	): setWorldCitiesForecastData {
		return {
			type: "SET_WORLD_CITIES_FORECAST_DATA",
			worldCitiesData: payload,
		};
	},

	setWorldCitiesForecastDate(payload: Date): setWorldCitiesForecastDate {
		return {
			type: "SET_WORLD_CITIES_FORECAST_DATE",
			date: payload,
		};
	},

	setWorldLocation(payload: {
		id: string;
		name: string;
	}): setWorldCitiesLocation {
		return {
			type: "SET_WORLD_CITIES_LOCATION",
			payload,
		};
	},

	setObervationDate(payload: {
		date: Date;
		action: "prev" | "next";
		type: "hours" | "day";
	}) {
		const { date, type, action } = payload;

		return ({ dispatch }: { dispatch: WeatherDispatch }) => {
			let newDate: Date;

			switch (action) {
				case "next":
					newDate =
						type === "hours"
							? new Date(date.setHours(date.getHours() + 3))
							: new Date(date.setDate(date.getDate() + 1));
					break;
				case "prev":
					newDate =
						type === "hours"
							? new Date(date.setHours(date.getHours() - 3))
							: new Date(date.setDate(date.getDate() - 1));
					break;

				default:
					return;
			}

			dispatch.updateObervationDate(getClosestPastDate(newDate));
		};
	},

	/* search */
	searchCityById(payload: {
		cityId: string;
		cityNameEn: string;
		cityNameAr: string;
	}) {
		return ({ dispatch }: { dispatch: WeatherDispatch }) => {
			dispatch.setLocation(payload);
		};
	},

	setPrevisionDateCard({
		date,
		type,
	}: {
		date: Date;
		type: "weather" | "marine" | "world";
	}) {
		return ({ dispatch }: { dispatch: WeatherDispatch }) => {
			switch (type) {
				case "weather":
					dispatch.setNewDatePrevision(date);
					break;
				case "marine":
					dispatch.setNewMarineDatePrevision(date);
					break;
				case "world":
					dispatch.setWorldCitiesForecastDate(date);
					break;

				default:
			}
		};
	},

	setPrevisionDate(payload: {
		action: "prev" | "next";
		dateStore: Date;
		forecastType: "weather" | "marine";
	}) {
		return ({ dispatch }: { dispatch: WeatherDispatch }) => {
			const { action, dateStore, forecastType } = payload;
			const newDate = new Date(dateStore);

			if (action === "prev") {
				newDate.setDate(newDate.getDate() - 1);
			} else {
				newDate.setDate(newDate.getDate() + 1);
			}

			switch (forecastType) {
				case "weather":
					dispatch.setNewDatePrevision(newDate);
					break;
				case "marine": {
					dispatch.setNewMarineDatePrevision(newDate);
					break;
				}

				default:
			}
		};
	},
};
